export default __webpack_public_path__ + "static/willam-11fcf489890535b24c24526e74efd6fa.jpg";